import { createContext, useContext } from "react";

const noop = () => {};
const noopBulkCall = async () => ({
  success: 0,
  failed: 0,
  cancelled: true,
});

export const fallbackShellContext = {
  showToast: noop,
  registerPageControls: noop,
  resetPageControls: noop,
  openOutboundModal: noop,
  runBulkCalls: noopBulkCall,
};

export const ShellContext = createContext(fallbackShellContext);

export default function useShellContext() {
  return useContext(ShellContext) || fallbackShellContext;
}
